var _foreignObject, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVigil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("switch", null, _foreignObject || (_foreignObject = /*#__PURE__*/React.createElement("foreignObject", {
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45 45h260v260H45z",
    style: {
      opacity: 0.4
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280.694 136.639v4.889l16.556-6.861v-1.945z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.5 73H277v204h-19.5z",
    style: {
      fill: "#bec9ca"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M257.5 142.444 277 137.5v5.5l-6 2.5a21.3 21.3 0 0 1-.444 4.444c-.929 4.461-3.065 7.439-5.166 10.304a43 43 0 0 1-7.889 8.196z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M234.438 63.417h19.5v204h-19.5z",
    style: {
      fill: "#bec9ca"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m234.438 139.792 19.5-4.917v27.875a38.54 38.54 0 0 1-19.5 6.916z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M211.375 79.472h19.5v204h-19.5z",
    style: {
      fill: "#bec9ca"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m211.375 161.667 19.5-4.667v29.056a56.1 56.1 0 0 1-19.5-2.333z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.312 69.521h19.5v204h-19.5z",
    style: {
      fill: "#bec9ca"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m188.312 144.778 4.41 10.5 15.09-3.611v19.646c-1.898-.791-5.395-2.556-8.396-6.208a21.4 21.4 0 0 1-3.688-6.604l-7.417 1.583v-15.306z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M165.25 64.083h19.5v204h-19.5zM142.188 69h19.5v204h-19.5z",
    style: {
      fill: "#bec9ca"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m142.188 151.528 15.396 3.806 4.104-9.361v15.056l-5.215-1.556a20.5 20.5 0 0 1-5.5 8.278 20.5 20.5 0 0 1-8.785 4.708z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.125 73h19.5v204h-19.5z",
    style: {
      fill: "#bec9ca"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m119.125 151.375 19.5 4.847v22.333a63.8 63.8 0 0 1-19.5 2.101z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96.062 74.271h19.5v204h-19.5z",
    style: {
      fill: "#bec9ca"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m96.062 145.75 19.5 4.792V180.5a32.8 32.8 0 0 1-8.208-1.283 33.1 33.1 0 0 1-11.292-5.842z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73 73h19.5v204H73z",
    style: {
      fill: "#bec9ca"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m73 137.396 19.5 4.792v25.938a45 45 0 0 1-5.042-4.833c-2.468-2.767-5.563-6.237-7.128-11.522a23.5 23.5 0 0 1-.955-6.186L73 143.002zm-3.639-.729v4.777L52.417 134.5v-1.944z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVigil);
export default __webpack_public_path__ + "static/media/vigil.7020a190cd62a483a276e02ff657ca30.svg";
export { ForwardRef as ReactComponent };